// components/AddPersonaForm.jsx
import React, { useState, useEffect } from "react";
import { postPersona } from "../helpers/rutaPersonas";   // ← SINGULAR
import { getLocalidades } from "../helpers/rutaLocalidades";
import "../css/addpersonaform.css";

const AddPersonaForm = ({ setShow, onSaved }) => {
  const [formValues, setFormValues] = useState({
    nombre: "", domicilio: "", telefono: "", email: "",
    localidad: "", perfil: "VENDEDOR", activo: true,
  });

  const [localidades, setLocalidades] = useState({ data: [], loading: true, error: null });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const resp = await getLocalidades();
        const items = resp?.localidades || resp?.data?.localidades || resp?.data || [];
        if (mounted) setLocalidades({ data: items, loading: false, error: null });
      } catch (err) {
        if (mounted) setLocalidades({ data: [], loading: false, error: err?.message || "Error al cargar localidades" });
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues(v => ({ ...v, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        nombre: formValues.nombre,
        domicilio: formValues.domicilio,
        telefono: formValues.telefono,
        email: formValues.email,
        localidad: formValues.localidad || null,
        perfil: formValues.perfil,
        activo: formValues.activo,
      };
      await postPersona(payload);
      // reset + cerrar + notificar a la page para refrescar tabla
      setFormValues({ nombre: "", domicilio: "", telefono: "", email: "", localidad: "", perfil: "VENDEDOR", activo: true });
      if (onSaved) onSaved();          // ← dispara reload en Personas.jsx
      // if (setShow) setShow(false);  // (lo hace onSaved)
    } catch (err) {
      console.error("❌ Error creando persona:", err);
      alert("No se pudo crear la persona. Revisá los datos e intentá de nuevo.");
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        {/* … (el mismo markup de inputs que ya tenés) … */}
        {/* Nombre */}
        <div className="form-row">
          <div className="form-group mt-3 col-sm-5">
            <label>Nombre</label>
            <input type="text" className="form-control" name="nombre" maxLength="50" required
              value={formValues.nombre} onChange={handleChange} />
          </div>
          <div className="form-group mt-3 col-sm-5">
            <label>Domicilio</label>
            <input type="text" className="form-control" name="domicilio" maxLength="100"
              value={formValues.domicilio} onChange={handleChange} />
          </div>
          <div className="form-group mt-3 col-sm-2">
            <label>Teléfono</label>
            <input type="text" className="form-control" name="telefono" maxLength="30"
              value={formValues.telefono} onChange={handleChange} />
          </div>
        </div>
        {/* Email / Localidad */}
        <div className="form-row">
          <div className="form-group mt-3 col-sm-4">
            <label>Email</label>
            <input type="email" className="form-control" name="email" maxLength="50"
              value={formValues.email} onChange={handleChange} />
          </div>
          <div className="form-group mt-3 col-sm-4">
            <label>Localidad</label>
            <select className="form-control" name="localidad" value={formValues.localidad} onChange={handleChange}>
              <option value="">Elija opción</option>
              {localidades.data.map((loc) => (
                <option key={loc._id} value={loc._id}>
                  {loc.descripcion || loc.localidad || "Sin nombre"}
                </option>
              ))}
            </select>
            {localidades.error && <small className="text-danger">{localidades.error}</small>}
          </div>
          <div className="form-group mt-3 col-sm-2">
            <label>Perfil</label>
            <select className="form-control" name="perfil" value={formValues.perfil} onChange={handleChange} required>
              <option value="VENDEDOR">VENDEDOR</option>
              <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
            </select>
          </div>
          <div className="form-group col-sm-2 d-flex align-items-end">
            <div className="form-check">
              <input id="chkActivo" className="form-check-input" type="checkbox" name="activo"
                checked={formValues.activo} onChange={handleChange} />
              <label className="form-check-label" htmlFor="chkActivo">Activo</label>
            </div>
          </div>
        </div>
        {/* Botón */}
        <div>
          <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">Guardar</button>
        </div>
      </form>
    </div>
  );
};

export default AddPersonaForm;
